import StackIconPath from "@ingka/ssr-icon/paths/stack";

export default StackIconPath;
